import { find } from 'lodash';
import { Component, OnInit, EventEmitter, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  Tarea,
  Const,
  Context,
  DynamicComponentForm,
  ConfigFinishDefault,
  TaskEvent,
  ConfirmComponent,
  LiquidacionNoPaga,
  ExpedienteLiquidacion,
  Documento,
  RevisionDocumento,
  HistorialDocumento,
  DocumentoDetalle,
  FuncionDocumento,
  LiquidationsCinco
} from '@app/shared';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InstanceLiquidationDataService } from './shared/instance-liquidation.data.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-instance-liquidation',
  templateUrl: './instance-liquidation.component.html',
  styleUrls: ['./instance-liquidation.component.scss'],
  providers: [InstanceLiquidationDataService, AuthenticationService]
})
export class InstanceLiquidationComponent extends DynamicComponentForm implements OnInit, OnDestroy {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Contiene la ruta de el InformacionTablaMaestra
  urlIframe = '';
  // Contiene el id de la liquidacion para la url del iframe
  urlLiquidation = '';
  // Contiene el id del expediente para la url del iframe
  urlExpediente = '';
  // Contiene el id del documento para la url del iframe
  urlDocumento = '';
  // Contiene el id del usuario para la url del iframe
  urlUsuario = '';
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define la finaliacioncion de la tarea
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Variable que activa el gift de cargando cuando se está finalizando
  isLoadingFinish = false;
  // Define cuando se activa el boton de liquidar
  btnLiquidar = false;
  // Define cuando se muestra el boton de guardar liquidación
  saveLiquidation = false;
  // Define cuando esta en la vista de documentos o en la de la tarea
  wimdowDocs = false;
  // Extensiones de los archivos permitidas
  extensions: Array<String> = ['jpg', 'png', 'pdf', 'xlsx', 'xls', 'docx', 'tiff', 'tif', 'doc'];
  // Tarea actual
  task: Tarea;
  // Tarea liquidacion
  taskLiquidation: Tarea;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene la informacion del expediente
  expediente: ExpedienteLiquidacion;
  // contiene el tramite de la liquidacion;
  instance: any;
  // Formulario de liquidacion
  formLiquidation: FormGroup = new FormGroup({
    cboLiquidations: new FormControl(null, [Validators.required]),
  });
  // Liquidaciones a mostrar en el selector
  liquidations: Array<LiquidationsCinco> = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor(
    private ilds: InstanceLiquidationDataService,
    private as: AuthenticationService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    const user = this.as.getCredentials();
    this.urlUsuario = '&usuario=' + user.info_persona.identificacion;
    if (this.task.documentos && this.task.documentos.length) {
      this.task.documentos.forEach(doc => {
        if (doc.documentos_detalle && doc.documentos_detalle.length) {
          this.urlDocumento = '&iddocumento_cinco=' + doc.documentos_detalle[0].id_documento;
        }
      });
    }
    this.getLiquidations();
    this.ilds.getExpediente(this.task.id).subscribe(expediente => {
      this.expediente = expediente;
      /*if (expediente.id_expediente_cita) {
        this.urlExpediente += '?idexpediente=' + expediente.id_expediente_cita;
      }*/
    });
    this.validDocs();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla la accion de guardar en el formulario y asocia el expediente a la liquidacion seleccionada
   *
   * @param {*} data
   * @memberof InstanceLiquidationComponent
   */
  associateLiquidation() {
    if (this.formLiquidation.value.cboLiquidations) {
      this.formLiquidation.controls['cboLiquidations'].disable();
      this.ilds.associationLiquidationExpediente(
        this.task.id,
        this.formLiquidation.value.cboLiquidations
      ).then(_res => {
        this.saveLiquidation = true;
        const liquidationSelect = find(
          this.liquidations,
          {
            id_liquidacion: this.formLiquidation.value.cboLiquidations
          }
        );
        if (liquidationSelect) {
          this.liquidations = [liquidationSelect];
          this.formLiquidation.controls['cboLiquidations'].setValue(this.liquidations[0].id_liquidacion);
        }
      }).catch(_error => {
        this.formLiquidation.controls['cboLiquidations'].enable();
      });
    } else {
      this.toastr.warning('Debe seleccionar una liquidación', 'Información incompleta');
    }
  }

  /**
   * Abre el modal con el iframe para generar la liquidacion
   *
   * @param {TemplateRef<any>} template
   * @memberof InstanceLiquidationComponent
   */
  async openFormLiquidation(template: TemplateRef<any>) {
    if (this.formLiquidation.value.cboLiquidations) {
      if (typeof this.formLiquidation.value.cboLiquidations === 'number') {
        this.instance = {
          id_tramite: this.formLiquidation.value.cboLiquidations
        };
      } else {
        this.instance = {
          id_tramite: this.formLiquidation.value.cboLiquidations[0]
        };
      }
      this.modalRef = this.modalService.show(
        template,
        {
          class: 'modal-personalized',
          ignoreBackdropClick: true
        }
      );
    } else {
      this.instance = await this.ilds.newInstance(this.task.id);
      this.modalRef = this.modalService.show(
        template,
        {
          class: 'modal-personalized',
          ignoreBackdropClick: true
        }
      );
      // this.toastr.warning('El expediente no se encuentra radicado en CITA', 'Información incompleta');
    }
  }

  onHide(e: boolean) {
    this.modalRef.hide();
    // cargar liquidaciones por tarea
    if (e === true) {
      this.getLiquidations();
    } else {
      this.cancelLiquidations();
    }
  }


  /**
   * Abre el componente de documentos
   *
   * @memberof InstanceLiquidationComponent
   */
  openDocs() {
    this.wimdowDocs = true;
  }

  /**
   * Cierra el componete de documentos
   *
   * @param {boolean} res
   * @memberof InstanceLiquidationComponent
   */
  closeDocs(res: boolean) {
    if (res) {
      this.wimdowDocs = false;
    }
  }

  /**
   * actualiza la informacion de la tarea con respecto a los documentos subidos
   *
   * @param {*} data
   * @returns {*}
   * @memberof InstanceLiquidationComponent
   */
  documentUpdate(data: Documento[]): any {

    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    this.validDocs();
    this.updateDocumentCita();
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof InstanceLiquidationComponent
   */
  validDocs() {
    let valid = true;
    if (this.task.documentos.length > 0) {
      for (let indexDoc = 0; indexDoc < this.task.documentos.length; indexDoc++) {
        let validUpload = false;
        if (this.task.documentos[indexDoc].funciones.length > 0) {
          // Verifica propiedad de la forma e inhabilita boton de liquidar
          if (this.task.tarea_forma && this.task.tarea_forma.length && this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.solo_asociacion && this.formLiquidation.value.cboLiquidations == null) {
            this.btnLiquidar = true;
          } else {
            this.btnLiquidar = false;
          }
          for (let indexFuntion = 0;
            indexFuntion < this.task.documentos[indexDoc].funciones.length;
            indexFuntion++) {
            if (this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload) {
              if (this.task.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                validUpload = true;
                break;
              }
            }
          }
        }
        if (validUpload) {
          if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
            if (this.task.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
              if (this.task.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                const versionDoc = this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                for (let indexHistory = 0;
                  indexHistory < this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                  indexHistory++) {
                  if (this.task.documentos[indexDoc]
                    .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                    if (this.task.documentos[indexDoc]
                      .documentos_detalle[0].historial[indexHistory].revision.length) {
                      let idReview = 0;
                      for (let indexReview = 0;
                        indexReview < this.task.documentos[indexDoc]
                          .documentos_detalle[0].historial[indexHistory].revision.length;
                        indexReview++) {
                        if (this.task.documentos[indexDoc]
                          .documentos_detalle[0].historial[indexHistory]
                          .revision[indexReview].id_revision > idReview) {
                          idReview = this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision;
                        }
                      }
                      for (let indexReview = 0;
                        indexReview < this.task.documentos[indexDoc]
                          .documentos_detalle[0].historial[indexHistory].revision.length;
                        indexReview++) {
                        if (this.task.documentos[indexDoc]
                          .documentos_detalle[0].historial[indexHistory]
                          .revision[indexReview].id_revision === idReview) {
                          if (!this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].revision) {
                            valid = false;
                            break;
                          } else {
                            valid = true;
                          }
                        }
                      }
                      if (!valid) {
                        break;
                      }
                    } else {
                      valid = true;
                    }
                  }
                }
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          } else {
            valid = false;
            break;
          }
        }
        if (!valid) {
          break;
        }
      }
    }
    if (valid) {
      if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
        for (const taskAssociation of this.task.tarea_asociacion) {
          if (taskAssociation.documentos.length > 0) {
            for (let indexDoc = 0; indexDoc < taskAssociation.documentos.length; indexDoc++) {
              let validUpload = false;
              if (taskAssociation.documentos[indexDoc].funciones.length > 0) {
                for (let indexFuntion = 0;
                  indexFuntion < taskAssociation.documentos[indexDoc].funciones.length;
                  indexFuntion++) {
                  // tslint:disable-next-line: max-line-length
                  if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload) {
                    if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                      validUpload = true;
                      break;
                    }
                  }
                }
              }
              if (validUpload) {
                if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                    if (taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                      const versionDoc = taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                      for (let indexHistory = 0;
                        indexHistory < taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                        indexHistory++) {
                        if (taskAssociation.documentos[indexDoc]
                          .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                          if (taskAssociation.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length) {
                            let idReview = 0;
                            for (let indexReview = 0;
                              indexReview < taskAssociation.documentos[indexDoc]
                                .documentos_detalle[0].historial[indexHistory].revision.length;
                              indexReview++) {
                              if (taskAssociation.documentos[indexDoc]
                                .documentos_detalle[0].historial[indexHistory]
                                .revision[indexReview].id_revision > idReview) {
                                idReview = taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision;
                              }
                            }
                            for (let indexReview = 0;
                              indexReview < taskAssociation.documentos[indexDoc]
                                .documentos_detalle[0].historial[indexHistory].revision.length;
                              indexReview++) {
                              if (taskAssociation.documentos[indexDoc]
                                .documentos_detalle[0].historial[indexHistory]
                                .revision[indexReview].id_revision === idReview) {
                                if (!taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].revision) {
                                  valid = false;
                                  break;
                                } else {
                                  valid = true;
                                }
                              }
                            }
                            if (!valid) {
                              break;
                            }
                          } else {
                            valid = true;
                          }
                        }
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                } else {
                  valid = false;
                  break;
                }
              }
              if (!valid) {
                break;
              }
            }
            if (!valid) {
              break;
            }
          }
        }
      }
    }
    if (valid) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Actualiza el documento en cita con el de cinco
   *
   * @memberof InstanceLiquidationComponent
   */
  updateDocumentCita() {
    if (this.formLiquidation.value.cboLiquidations && this.saveLiquidation) {
      if (
        this.task.documentos &&
        this.task.documentos.length &&
        this.task.documentos[0].documentos_detalle &&
        this.task.documentos[0].documentos_detalle.length
      ) {
        this.ilds.getUpdateDocumentLiquidation(
          this.formLiquidation.value.cboLiquidations,
          this.task.documentos[0].documentos_detalle[0].id_documento
        );
      }
    }
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof InstanceLiquidationComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof LiquidationDeterminationComponent
   */
  finishConfirm() {
    if (this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Obtiene las liquidaciones a mostrar en el selector de liquidaciones
   *
   * @private
   * @memberof InstanceLiquidationComponent
   */
  private getLiquidations() {
    this.ilds.getUnpaidLiquidationsCinco().subscribe(liquidations => {
      if (liquidations.length) {
        liquidations.forEach(liquidation => {
          liquidation.key = liquidation.id_liquidacion + ' - $' + liquidation.valor_liquidacion;
        });
      }
      this.liquidations = liquidations;
    });
    this.ilds.getUnpaidLiquidationsCincoTask(this.task.id).subscribe(liquidations => {
      if (liquidations.length) {
        liquidations.forEach(liquidation => {
          liquidation.key = liquidation.id_liquidacion + ' - $' + liquidation.valor_liquidacion;
        });
        this.liquidations = liquidations;
        if (this.liquidations.length === 1 && this.liquidations[0].id_tramite) {
          this.formLiquidation.controls['cboLiquidations'].setValue(this.liquidations[0].id_tramite);
          this.formLiquidation.controls['cboLiquidations'].disable();
          this.saveLiquidation = true;

          // Validacion de contenido del selector
          if (this.task.tarea_forma && this.task.tarea_forma.length && this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.solo_asociacion && this.formLiquidation.value.cboLiquidations == null) {
            this.btnLiquidar = true; 
          } else {
            this.btnLiquidar = false;
          }
        }
      }
    });
  }

  private async cancelLiquidations() {
    let resp = await this.ilds.cancelLiquidation(this.instance.id_tramite);
    if (resp) {
      this.formLiquidation.controls['cboLiquidations'].setValue(null);
      this.formLiquidation.controls['cboLiquidations'].enable();
      this.saveLiquidation = false;
      this.getLiquidations();
    } else {
      this.getLiquidations();
    }
  }

  /**
   * Verifica contenido del selector para habilitar el boton de liquidar
   * @param data
   */
  liquidatonSelected(data:any){
    if (this.task.tarea_forma && this.task.tarea_forma.length && this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.solo_asociacion && data != undefined) {
      this.btnLiquidar = false;
    } else {
      this.btnLiquidar = true; 
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/instance-liquidation/instance-liquidation.component.ts